import React from 'react';  
import './index.css';
import {Icon} from 'antd'
import { ActionSheet,  Toast, Button } from 'antd-mobile';
import history from 'common/history';
import userRequest, {userApi} from 'common/request';
import {
    Link
} from 'react-router-dom'; 
import {
        Douban,
        Facebook,
        Google,
        Qq,
        Qzone,        
        Twitter,
        Weibo,
        Linkedin,
        TencentWB,        
        BaiduPostBar,
        Email,
        Wx
    } from 'share-react'
 
const isIPhone = new RegExp('\\biPhone\\b|\\biPod\\b', 'i').test(window.navigator.userAgent);
let wrapProps;
if (isIPhone) {
  wrapProps = {
    onTouchStart: e => e.preventDefault(),
  };
}

const shareicon = {
  QqIcon : function(){
              return(
                <Qq  style={{ width: 36 }} >
                  <img src={'https://gw.alipayobjects.com/zos/rmsportal/SxpunpETIwdxNjcJamwB.png'} alt='' style={{ width: 36 }} />
                </Qq>
              )
           }, 
  QzoneIcon : function(){
                return(
                <Qzone  style={{ width: 36 }} >
                  <img src={'https://gw.alipayobjects.com/zos/rmsportal/cTTayShKtEIdQVEMuiWt.png'} alt='' style={{ width: 36 }} />
                </Qzone>
                )
              },

  WeiboIcon : function(){
                return(
                  <Weibo  style={{ width: 36 }} >
                    <img src={'https://gw.alipayobjects.com/zos/rmsportal/wvEzCMiDZjthhAOcwTOu.png'} alt='' style={{ width: 36 }} />
                  </Weibo>
                )
              }
  }

class InfoBottom extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      clicked: 'none'
    };
  }

  handleLike(){ 
    this.props.recordClick()
  }
 
  dataList = [
      {  title: 'QQ' ,icon:shareicon.QqIcon()},
      {  title: '新浪微博',icon:shareicon.WeiboIcon() },
      {  title: 'QQ空间' ,icon:shareicon.QzoneIcon()},
    ].map(obj => ({
      icon: obj.icon,
      title: obj.title,
    }));

  showShareActionSheet = () => {
    ActionSheet.showShareActionSheetWithOptions({
      options: this.dataList,
      message: '分享到',
    },
    (buttonIndex) => {
      this.setState({ clicked1: buttonIndex > -1 ? this.dataList[buttonIndex].title : 'cancel' });
      // also support Promise
      return new Promise((resolve) => {
        setTimeout(resolve, 1000);
      });
    });
  }

  push(sid,content){
    const {id, permission} = this.props
    if (permission.userType == 'guest') return
    if(content&&content.type){
        if(content.type==='video'){
          history.push('/labroomvideo/courseid='+id+'&sid='+sid)
        }else if(content.type==='experi'){
          history.push( '/labroomexper/courseid='+id+'&sid='+sid)
        }else if(content.type==='exam') {
           window.open(window.AppConfig.examUrl+'?exam-phone-callback&basicid='+content.basicid+'&subjectid='+sid+'&course_id='+id)
        }
    }else {
      console.log('content is null')
    }
  }

  judgeObj(obj) {
    if(obj !== "" && obj !== undefined && obj !== {} && String(obj).length > 0) {
      return true
    }else {
      return false
    }
  }

  judge(key, lastCourseId){
    const {finishedListLock, finishedList, id, user_id} = this.props;
    let result = []
    let allCourse = JSON.parse(localStorage.getItem('courseSubject'))
    let findIngCourse = ''
    let findWaitCourse = ''
    let findSuccCourse = ''
    let randomCourse = ''
    let findedCourseid = lastCourseId
    let findedCourseContent = ''
    
    if(key.information_data !== undefined && 
      key.information_data.subject_lock !== undefined &&
      key.information_data.subject_lock == "1") {
        if( (finishedListLock !== undefined && finishedListLock.size !== 0) &&
        (finishedList !== undefined && finishedList.size == 0) ){
          finishedListLock.toJS().map(item => {
              if(!result[item.SubId]){
                  result[item.SubId] = item.Auth
              }
          })

          for (let item of allCourse){
            if(item.childs.length !== 0){
              for(let child of item.childs) {
                if(child.childs.length !== 0) {
                  for(let eve of child.childs) {
                    if(findedCourseid == eve.id ) {
                      findedCourseContent = eve
                      break
                    }
                    else if(result[eve.id] && result[eve.id] == 'ing'){
                      findIngCourse = eve
                    }else if(result[eve.id] && result[eve.id] == 'wait') {
                      findWaitCourse = eve
                    }else if(result[eve.id] && result[eve.id] == 'succ') {
                      findSuccCourse = eve
                    }else {
                      randomCourse = eve
                    }
                  }
                }
              }
            }
          }
          if(findedCourseContent.id !== undefined){
            return <Button onClick={() => this.push(findedCourseContent.id, findedCourseContent.content)} className="enter-btn">继续学习</Button> 
          }else if(findedCourseContent.length == 0 && findIngCourse.id !== undefined && findSuccCourse.length == 0){
            return <Button onClick={() => this.push(findIngCourse.id, findIngCourse.content)} className="enter-btn">进入学习</Button> 
          }else if(findedCourseContent.length == 0 && findIngCourse.length == 0 && findSuccCourse.length == 0) {
            return alert('没有已解锁课程') 
          }
        }else {
          let tempFisrt = ''
          let tempLearned = ''
          for (let item of allCourse){
            if(item.childs.length !== 0){
              for(let child of item.childs) {
                if(child.childs.length !== 0) {
                  tempFisrt = child.childs[0]
                  for(let eve of child.childs) {
                    if(findedCourseid == eve.id ) {
                      findedCourseContent = eve
                      break
                    }else if(eve.Duration !== undefined) {
                      tempLearned = eve
                    }
          }}}}}
        if( findedCourseContent) { 
          return <Button onClick={() => this.push(findedCourseContent.id, findedCourseContent.content)} className="enter-btn">继续学习</Button> }
        else {
          return tempLearned.length ?  <Button onClick={() => this.push(tempLearned.id, tempLearned.content)} className="enter-btn">继续学习</Button> : <Button onClick={() => this.push(tempFisrt.id, tempFisrt.content)} className="enter-btn">进入学习</Button> 
        }
        }
    }else {
      let tempFisrt = ''
      let tempLearned = ''
      for (let item of allCourse){
        if(item.childs.length !== 0){
          for(let child of item.childs) {
            if(child.childs.length !== 0) {
              tempFisrt = child.childs[0]
              for(let eve of child.childs) {
                if(findedCourseid == eve.id ) {
                  findedCourseContent = eve
                  break
                }else if(eve.Duration !== undefined) {
                  tempLearned = eve
                }
      }}}}}
      if( findedCourseContent) { 
        return <Button onClick={() => this.push(findedCourseContent.id, findedCourseContent.content)} className="enter-btn">继续学习</Button> }
      else {
        return tempLearned.length ?  <Button onClick={() => this.push(tempLearned.id, tempLearned.content)} className="enter-btn">继续学习</Button> : <Button onClick={() => this.push(tempFisrt.id, tempFisrt.content)} className="enter-btn">进入学习</Button> ;
      }
    }
  }

  render(){
    const {id, timeInfo, finishedListLock, subject, finishedList, user_id, lastCourseId} =this.props;
    console.log(id, user_id, timeInfo, subject, 'wosi shazigggggggggggggggggg')
    return (
        <div className="info-bottom">
          <div className="bottom-icon-box">
            {/*<div className="bottom-actions">*/}
              {/*<div className="bottom-icon"  */}
                {/*onClick={()=>{this.handleLike()}}>*/}
               {/*<Icon type="heart" */}
                {/*theme={this.props.collect?'filled':null}*/}
                {/*/>*/}
              {/*</div>*/}
            {/*</div>*/}
            {/*<div className="bottom-actions">*/}
              {/*<div className="bottom-icon" onClick={this.showShareActionSheet}>*/}
                {/*<img src={require('./img/icon_share.png')} alt=""/>*/}
              {/*</div>*/}
            {/*</div> */}
        </div>
        <div className="enter-btn">
          {
            this.judge(timeInfo.toJS(), lastCourseId)
          }
        {/* <Button onClick={() => this.getRoute()} className="enter-btn">继续学习</Button> */}
        {/* `/labroom/${this.props.id}` */}
        {/* tiemInfo={timeInfo} */}
        </div>
       </div>
        
      )
  }
}
export default InfoBottom;